"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[717],{

/***/ 717:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ backInStock)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function backInStock({ wrapper }) {
  const klaviyoId = 'XjLncj'
  const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoId}`
  const headers = {
    accept: 'application/json',
    revision: '2024-02-15',
    'content-type': 'application/json',
  }

  const selectors = {
    backInStockMessage: '.js-bis-notification',
    backInStockSubmit: '.js-bis-submit',
    backInStockForm: '.bis--form',
    backInStockEmail: '#bis-input',
    idInput: '.js-hidden-select',
  }

  const cache = {
    product: {},
    variant: {},
    title: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('product-title'),
    $wrapper: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper),
    $backInStockMessage: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.backInStockMessage),
    $backInStockSubmit: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.backInStockSubmit),
    $backInStockForm: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.backInStockForm),
    $backInStockEmail: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.backInStockEmail),
  }

  ;(function init() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('variant-selector:change', update)
    cache.$backInStockSubmit.on('click', subscribeToBIS)
  })()

  function update(event, { variant, product, isUpsell }) {
    if (isUpsell) return

    cache.variant = variant
    cache.product = product

    if (cache.variant) {
      const message = `Sign up for notifications when the ${cache.product.title || cache.title} becomes available!`
      cache.$backInStockMessage.text(message)
    }

    if (cache.variant?.available) {
      cache.$wrapper.hide()
    } else {
      cache.$backInStockForm.show()
      cache.$wrapper.show()
    }
  }

  function subscribeToBIS(e) {
    // product/back-in-stock.js component
    let variantId = cache.variant.id
    const email = cache.$backInStockEmail.val()

    if (!variantId) {
      variantId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.idInput).val()
    }

    if (variantId && email) {
      sendBISRequest({ email, variantId })
    }
  }

  function sendBISRequest({ email, variantId }) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
    }

    // fetch, promise JS
    fetch(url, options)
      .then((response) => {
        submitSuccess(response)
      })
      .catch((err) => console.error(err))
  }

  function submitSuccess(response) {
    const messageText = `You're on the list! You'll receive an email when the ${
      cache.product.title || cache.title
    } becomes available.`
    cache.$backInStockMessage.text(messageText)
    cache.$backInStockForm.hide()
  }
}


/***/ })

}]);